import { ReactToExerciseEventType, UpdateObjective } from "Phaser/EventBus";
import Tutorial, { ChapterType, ExerciseScene } from "Types/ExerciseData";
import { AddEventsAndMergeTimestamps, Timestamps } from "Utils/ChaptersToTimestamps";
import { Exercise, StaffExercise } from "Utils/TutorialConfigHelper";
import timestamps from "./level10.json";

const Level10: Tutorial = {
  level: 10,
  end: '2:13',
  videoUrl: 'level-10.mp4',
  sections: [
    {
      chapters: [
        {
          title: 'G in the Treble Clef',
          start: '0:0',
          data: [ChapterType.Lecture]
        },
        {
          title: 'G on the Keyboard',
          start: '0:12',
          data: [ChapterType.Lecture]
        },
        {
          title: 'Find G',
          start: '0:24',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.PianoScene,
                {
                  start: 'A0',
                  end: 'C8',
                  transition: 'Dissolve',
                  textPromptPosition: 'Top',
                  objectives: [
                    {
                      text: 'Play G on your keyboard.',
                      target: 'G4',
                    },
                  ],
                },
              ],
              events: [
              ],
            },
          ],
        }
      ]
    },
    {
      chapters: [
        {
          title: 'Playing with the 5th Finger',
          start: '0:30',
          data: [ChapterType.Lecture]
        },
        {
          title: 'Playing G',
          start: '0:37',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.NoTimeExercise,
                {
                  centre_align_horizontal: false,
                  padding_x: 100,
                  first_note_offset: 50,
                  objectives: [
                    {
                    },
                  ],
                },
              ],
              events: [
              ],
            }
          ]
        },
        {
          title: '5th Finger Technique',
          start: '0:43',
          data: [ChapterType.Lecture]
        },
        {
          title: 'Alternating Fingers',
          start: '1:09',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.NoTimeExercise,
                {
                  centre_align_horizontal: true,
                  objectives: [
                    {
                    },
                    {
                    },
                    {
                    }
                  ],
                },
              ],
              events: [
              ],
            }
          ]
        },
        {
          title: 'Playing in Time',
          start: '1:26',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.StaffExercise,
                {
                  objectives: [
                    {
                    },
                    {
                    },
                  ],
                },
              ],
              events: [
              ],
            }
          ]
        }
      ]
    },
    {
      chapters: [
        {
          title: 'Using Both Hands',
          start: '1:42',
          data: [ChapterType.Lecture]
        },
        {
          title: 'Alternating Hands',
          start: '1:49',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.StaffExercise,
                {
                  firstObjectiveAppearDelay: 500,
                  objectives: [
                    {
                      tempo: 72,
                      text: 'Play this line of music in sync with the metronome.',
                      paddingHorizontal: 20,
                      phrases: [],
                      videoCompleteDestination: '1:53.5',
                      videoSkipDestination: '1:54.5',
                    },
                  ],
                },
              ],
              events: [],
            }
          ]
        },
        Exercise("Hands Together", '0:0', StaffExercise({ objectives: [{}, {}] }), [])
      ]
    }
  ]
};
export default AddEventsAndMergeTimestamps(timestamps as Timestamps, Level10);
